<template>
    <div class="formItem" :class="{'formError' : error}">
        <label v-if="!onlyField">{{ label }}
            <span v-if="subLabel"> ({{ subLabel }})</span>
        </label>
        <v-textarea
                class="sr-textarea"
                hide-details
                no-resize
                :disabled="loading || readonly"
                :readonly="loading || readonly"
                :value="value"
                @input="$emit('input', $event)"
        >
        </v-textarea>
    </div>
</template>

<script>
  export default {
    props: {
      error: {
        type: Boolean,
        default: false
      },
      onlyField: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      subLabel: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: null
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>
